<template>
  <f7-app :params="f7params">
    <leftPanel
      v-if="canAccessApp && selection === 'GreenHouse'"
      :elements="opcionesMenuGreenHouse"
      :version="version"
      :show-to-default="devicePlatform === 'web'"
    />
    <leftPanel
      v-else
      :elements="opcionesMenuOpenAir"
      :version="version"
      :show-to-default="devicePlatform === 'web'"
    />
    <login v-if="loginNeeded && !requestNewPasssword" />
    <recoveryPassword
      v-if="loginNeeded && requestNewPasssword"
      :opened="requestNewPasssword"
    />
    <f7-view
      v-if="canAccessApp"
      main
      resizable
      class="safe-areas"
      url="/"
    >
      <f7-popup
        class="demo-popup"
        :opened="showMessage"
        @popup:closed="closePopup"
      >
        <f7-page>
          <f7-navbar
            name="msgEmail"
            :title="$t('Login_msgEmail_title')"
          >
            <f7-nav-right>
              <f7-link
                popup-close
              >
                {{ $t("Login_msgEmail_btnClose") }}
              </f7-link>
            </f7-nav-right>
          </f7-navbar>
          <f7-block>
            <p>{{ $t("Login_msgEmail_content") }}</p>
          </f7-block>
        </f7-page>
      </f7-popup>
    </f7-view>
  </f7-app>
</template>
<script>

import { Device } from 'framework7/framework7-lite.esm.bundle';
import { mapActions, mapState, mapMutations } from 'vuex';
import esMessages from 'devextreme/localization/messages/es.json';
import { loadMessages, locale } from 'devextreme/localization';
import { APP_VERSION, DEVICE_PLATFORM } from '../js/constants';
import cordovaApp from '../js/cordova-app';
import store from '../store/index';
import routes from '../js/routes';
import leftPanel from './LeftPanel.vue';
import opcionesMenuGreenHouse from '../json/menuListGreenHouse.json';
import opcionesMenuOpenAir from '../json/menuListOpenAir.json';
import Api from '../services/Api';
import login from '../pages/accounts/loginPage.vue';
import recoveryPassword from './accounts/RecoveryPassword.vue';
import EventBus from '../js/event-bus';

export default {
  components: {
    leftPanel, login, recoveryPassword,
  },
  store,
  data() {
    return {
      version: APP_VERSION,
      opcionesMenuGreenHouse,
      opcionesMenuOpenAir,
      showToDefault: true,
      devicePlatform: DEVICE_PLATFORM,
      // Framework7 Parameters
      f7params: {
        id: 'es.hispatec.vegsyst', // App bundle ID
        name: 'VegSyst-DSS-Suite', // App name
        theme: 'auto', // Automatic theme detection

        // App routes
        routes,
        // Input settings
        input: {
          scrollIntoViewOnFocus: Device.cordova && !Device.electron,
          scrollIntoViewCentered: Device.cordova && !Device.electron,
        },

        // Cordova Statusbar settings
        statusbar: {
          iosOverlaysWebView: true,
          androidOverlaysWebView: false,
          androidTextColor: 'black',
          androidBackgroundColor: '#FFFFFF',
          iosTextColor: 'black',
          iosBackgroundColor: '#FFFFFF',
        },
      },
      // Login screen data
      username: '',
      password: '',
    };
  },
  computed: {
    loginNeeded() {
      return this.loggedUser == null;
    },
    canAccessApp() {
      return this.loggedUser != null;
    },
    requestNewPasssword() {
      return (this.loggedUser == null && this.wantToRecoveryPass === true);
    },
    showMessage() {
      return this.messageChangePassword;
    },
    ...mapState('authentication', [
      'activationCode',
      'loggedUser',
      'appConfig',
      'wantToRemember',
      'wantToRecoveryPass',
      'changePassword',
      'messageChangePassword',
      'selection',
    ]),
  },
  beforeMount() {
    EventBus.$on('resetData', this.resetData);
  },
  beforeDestroy() {
    EventBus.$off('resetData');
  },
  created() {
    loadMessages(esMessages);
    loadMessages({
      es: {
        'vizExport-printingButtonText': this.devicePlatform !== 'android' ? 'Imprimir' : 'Exportar como',
        'vizExport-titleMenuText': 'Exportar',
        'vizExport-exportButtonText': 'Archivo {0}',
      },
    });
    locale('es');
  },
  mounted() {
    const self = this;
    this.$f7ready((f7) => {
      // Init cordova APIs (see cordova-app.js)
      if (Device.cordova) {
        cordovaApp.init(f7);
      }

      if (self.loggedUser) {
        if (self.wantToRemember) {
          Api.username = self.loggedUser.username;
          Api.token = self.loggedUser.token;
        } else {
          self.logout();
        }
      }
    });
  },
  methods: {
    closePopup() {
      this.setMessageChangePassword();
    },
    resetData() {
      this.resetNewProject();
      this.resetNewProjectOpenAir();
      this.resetResult();
    },
    ...mapActions('authentication', ['activateApp', 'deactivateApp', 'logout']),
    ...mapActions('AccessControl', ['scan']),
    ...mapActions('ProjectGreenHouse', ['resetNewProject']),
    ...mapActions('ProjectOpenAir', ['resetNewProjectOpenAir']),
    ...mapActions('Result', ['resetResult']),
    ...mapMutations('authentication', ['setMessageChangePassword']),
  },
};
</script>
